import React from 'react';
import Helmet from 'react-helmet';
import _ from 'lodash';
import Moment from 'moment';
import {
  SafetyDiaryRecoveryForm,
  SafetyDiaryRecoveryFormData,
} from '../components/forms/SafetyDiaryRecoveryForm';
import { Modal } from '../components/Modal';
import Information from '../components/modals/common/Information';
import { SafetyDiaryService } from '../services/SafetyDiaries';
import { RecoveryApproval } from '../components/modals/RecoveryApproval';
import { RecoveryUnapproval } from '../components/modals/RecoveryUnapproval';
import { RecoveryReject } from '../components/modals/RecoveryReject';
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';
import SafetyDiariesConstants from '../utilities/safetyDiariesConstants';
import { messageUtility } from '../utilities/messageUtility';
import { HEADER_CONSTANTS } from '../utilities/constants';
import { canSafetyDiaryApprove } from '../utilities/roleUtility';
import { ConferencePageHeader } from '../components/PageHeader';
import _slideLoader from '../utilities/slideLoader';
Moment.locale('ja');

const ModalState = {
  approval: 0,
  reject: 1,
  unapproval: 2,
};

/**
 * @description 巡回記録是正承認/否認
 */
export class SafetyDiariesRecoveryApproval extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fieldId: SessionStorageService.getFieldId(),
      userId: LocalStorageService.getUserId(),
      formData: SafetyDiaryRecoveryFormData,
      dataId: this.props.view.state.id || null, // FIXME: fix routing
      modalState: null,
      canApprove: false,
      visibleDialogFlag: false, // 開閉用ダイアログFlag
      apiMessage: '',
      title: '',
    };

    this.handleApproval = this.handleApproval.bind(this);
    this.handleUnapproval = this.handleUnapproval.bind(this);
  }

  componentDidMount() {
    // 更新時
    if (this.state.dataId) {
      const params = this.props.view.state.params || {
        date_type: SafetyDiariesConstants.dataType.entriesDate,
      };
      SafetyDiaryService.getDiary(
        this.state.fieldId,
        this.state.dataId,
        params
      ).then(response => {
        const safetyDiary = response.data.entities.safety_diary;
        if (safetyDiary.finish_flag === 1) {
          const approved = ModalState.approval;
          this.setState({ approved });
        }
        if (safetyDiary.finish_flag === 0 && safetyDiary.recovery_flag === 1) {
          const approved = ModalState.unapproval;
          this.setState({ approved });
        }
        if (safetyDiary.finish_flag === 0 && safetyDiary.recovery_flag === 0) {
          const approved = ModalState.reject;
          this.setState({ approved });
        }
        const formData = this.bindRecoveryData(
          SafetyDiaryRecoveryFormData,
          safetyDiary
        );
        const fixDateFormData = formData.recovery_date
          ? formData
          : { ...formData, recovery_date: Moment().format('YYYY/MM/DD') };
        this.setState({
          formData: fixDateFormData,
          canApprove: canSafetyDiaryApprove(safetyDiary),
        });
      });
    }
  }

  bindRecoveryData(bindTarget, bindSource) {
    const targetKeys = Object.keys(bindTarget);
    _.each(targetKeys, key => {
      if (!_.has(bindSource, key)) {
        return;
      }
      bindTarget[key] = bindSource[key];
    });
    return bindTarget;
  }

  /**
   * 承認時に呼ばれる
   * @param approvalCanceleFlag
   */
  handleApproval = approvalCanceleFlag => {
    this.postApproval(true, approvalCanceleFlag);
  };

  /**
   * 否認・承認解除時に呼ばれる
   * @param approvalCanceleFlag
   */
  handleUnapproval = approvalCanceleFlag => {
    this.postApproval(false, approvalCanceleFlag);
  };

  handleCloseModal = () => {
    this.setState({ modalState: null });
  };

  renderModal = modalState => {
    switch (modalState) {
      // 承認
      case ModalState.approval: {
        return (
          <RecoveryApproval
            onApprove={() => this.handleApproval(false)}
            onClose={() => {
              this.handleCloseModal();
            }}
          />
        );
      }
      // 承認解除
      case ModalState.unapproval: {
        return (
          <RecoveryUnapproval
            onUnapprove={() => this.handleUnapproval(true)}
            onClose={() => {
              this.handleCloseModal();
            }}
          />
        );
      }
      // 否認
      case ModalState.reject: {
        return (
          <RecoveryReject
            onReject={() => this.handleUnapproval(false)}
            onClose={() => {
              this.handleCloseModal();
            }}
          />
        );
      }
      default: {
        return null;
      }
    }
  };

  /**
   * 承認・否認・承認解除時に呼ばれる
   * @param approvalFlag 承認時: ture
   *                     否認・承認解除時: false
   * @param approvalCanceleFlag 承認時: false
   *                            否認時: false
   *                            承認解除時: true
   */
  postApproval = (approvalFlag, approvalCancelFlag) => {
    let postData = {
      finish_date: Moment().format('YYYYMMDD'),
      finish_flag: approvalFlag ? '1' : '0',
      approval_user_id: this.state.userId,
      approval_cancel_flag: approvalCancelFlag ? '1' : '0',
    };
    SafetyDiaryService.approval(
      this.state.fieldId,
      this.state.dataId,
      postData
    ).then(response => {
      if (response.result !== true) {
        this.handleVisibleDialog(
          true,
          response.data.message,
          messageUtility.getMessage('E-001-402')
        );
        return;
      }
      _slideLoader.close(this.props.vw);
    });
  };

  renderChangeEditButton = () => {
    if (this.state.dataId) {
      return (
        <button className='btn--stay' onClick={this.handleEditConfirm}>
          指摘事項を確認する
        </button>
      );
    }

    return null;
  };

  handleOpenNewSlide = object => {
    _slideLoader.close(this.props.vw);
    _slideLoader.show(
      object.name,
      { state: { ...object.state } },
      this.props.vw
    );
  };

  handleEditConfirm = () => {
    this.handleOpenNewSlide({
      name: 'SafetyDiariesConfirm',
      state: {
        id: this.state.dataId,
        dataId: this.state.dataId,
        params: this.props.view.state.params,
      },
    });
  };

  /**
   * @description ダイアログ開閉設定
   * @param {boolean} dialogName ダイアログFlag(falseの場合は、ダイアログを閉じる)
   * @param {string} apiMessage ダイアログに出力するメッセージ内容
   * @paaram {string} title
   */
  handleVisibleDialog(visibleDialogFlag, apiMessage = null, title) {
    this.setState({
      title,
      visibleDialogFlag,
      apiMessage,
    });
  }

  render() {
    return (
      <div className='slide-view show'>
        <Helmet>
          <title>{`${HEADER_CONSTANTS.conference} - 是正内容詳細`}</title>
        </Helmet>
        <div className='slide-view__view'>
          <ConferencePageHeader
            title={<div className='slide-view__title'>是正内容詳細</div>}
            leftComponent={
              <React.Fragment>
                {this.state.approved === ModalState.unapproval &&
                  this.state.canApprove && (
                    <React.Fragment>
                      <button
                        className='btn--effective'
                        onClick={() =>
                          this.setState({ modalState: ModalState.approval })
                        }
                      >
                        承認
                      </button>
                      <button
                        className='btn--negative'
                        onClick={() =>
                          this.setState({ modalState: ModalState.reject })
                        }
                      >
                        否認
                      </button>
                    </React.Fragment>
                  )}
                {this.state.approved === ModalState.approval &&
                  this.state.canApprove && (
                    <React.Fragment>
                      <button
                        className='btn--negative'
                        onClick={() =>
                          this.setState({ modalState: ModalState.unapproval })
                        }
                      >
                        承認解除
                      </button>
                    </React.Fragment>
                  )}
                {this.renderChangeEditButton()}
              </React.Fragment>
            }
            onClose={() => _slideLoader.close(this.props.vw)}
          />
          <div className='slide-view__body SafetyDiaries'>
            <SafetyDiaryRecoveryForm
              dataId={this.state.dataId}
              params={this.props.view.state.params}
              onUpdate={formData => {
                this.setState({ formData });
              }}
              preview={true}
              isSpace={true}
            />
          </div>
        </div>
        <Modal modalRoot={'root'} modalState={this.state.modalState !== null}>
          {this.renderModal(this.state.modalState)}
        </Modal>
        <Information
          visible={this.state.visibleDialogFlag === true}
          title={this.state.title}
          message={this.state.apiMessage}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => this.handleVisibleDialog(false)}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/SafetyDiariesRecoveryApproval.jsx